import { Flex, useToast, VStack } from '@chakra-ui/react'
import KalviumSdk from '@kalvi-education/kalvium-sdk'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import Toast from '../../../../common/Toast'
import { loginUser } from '../../utils/login'
import AuthTabs from '../common/AuthTabs'
import ProgramInfo from '../common/ProgramInfo'
import VerifyMobile from '../common/VerifyMobile/index'
import { LOGIN } from '../enums/authMode'

const AdmissionClientLogin = () => {
    const { clientSlug } = useParams()
    const [mobile, setMobile] = useState('')
    const [otp, setOtp] = useState('')
    const [isOtpVerified, setIsOtpVerified] = useState(false)
    const toast = useToast()
    const navigate = useNavigate()

    const {
        data: loginData,
        isError: isLoginError,
        error: loginError,
        isSuccess: isLoginSuccess,
    } = useQuery({
        queryKey: ['login', { otp: otp, mobile: mobile }],
        queryFn: async queryData => {
            return KalviumSdk.services.admission.login({
                mobile: queryData.queryKey[1].mobile,
                otp: queryData.queryKey[1].otp,
                clientSlug: clientSlug,
            })
        },
        enabled: isOtpVerified,
        retry: false,
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    })

    useEffect(() => {
        if (isLoginSuccess) {
            loginUser(loginData.token)
            navigate('/admission/dashboard')
        }
    }, [isLoginSuccess])

    useEffect(() => {
        if (isLoginError) {
            toast({
                duration: 10000,
                position: 'top-right',
                render: props => (
                    <Toast
                        status={'error'}
                        title={
                            loginError.message === 'Hall Ticket not found'
                                ? "Looks like you haven't registered for the KQ assessment yet. Please register to get started."
                                : loginError.message
                        }
                        {...props}
                    />
                ),
            })
        }
    }, [isLoginError])

    return (
        <Flex justifyContent="center" flexGrow={1} h="full" zIndex={1}>
            <Flex
                flexDirection={{ base: 'column', lg: 'row' }}
                maxWidth={'1312px'}
                flexGrow={1}
            >
                <ProgramInfo clientSlug={clientSlug} />
                <VStack
                    flexDirection={'column'}
                    flexGrow={1}
                    bgColor={'white'}
                    gap={0}
                    px={{ base: 4, md: 12, lg: 16 }}
                    pt={{ base: 4, md: 12 }}
                    alignItems={'stretch'}
                >
                    <Flex
                        position={'sticky'}
                        zIndex={999}
                        top={{ base: '78px', lg: -1 }}
                    >
                        <AuthTabs
                            activeTab={LOGIN}
                            basePath={`/admission/${clientSlug}`}
                        />
                    </Flex>
                    {/* Login Form */}
                    <Flex
                        id="verify-mobile-wrapper"
                        px={{ base: 4, md: 12, lg: 16 }}
                        flexGrow={1}
                        justifyContent={'center'}
                    >
                        <Flex
                            pt={'72px'}
                            id="verify-mobile-container"
                            pb={12}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <VerifyMobile
                                title="Enter your mobile number to get OTP"
                                onOtpVerified={(_mobile, _otp) => {
                                    setMobile(_mobile)
                                    setOtp(_otp)
                                    setIsOtpVerified(true)
                                }}
                            />
                        </Flex>
                    </Flex>
                </VStack>
            </Flex>
        </Flex>
    )
}

export default AdmissionClientLogin
